import React, { useState, useEffect } from 'react';
import IconClose from '@/icons/icon-close.svg';

export function SubscriptionBenefitsModal({ modalContent}) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    document.addEventListener('subscriptionModal:open', openModal);
    return () => {
      document.removeEventListener('subscriptionModal:open', openModal);
    };
  });

  if (modalContent == null || modalContent?.contentList?.length === 0) {
    return false
  }

  return (
    <div
      className={`fixed top-0 left-0 z-[100000] flex h-full w-full items-center justify-center ${
        isOpen
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      }`}
    >
      {/* Modal*/}
      <div
        className="relative z-[101] mx-auto max-h-[80%] w-[1200px] max-w-[80%] overflow-y-auto bg-white p-8"
        style={{
          width: '660px',
          maxWidth: '90%',
          textAlign: 'center',
          paddingBottom: '30px',
        }}
      >
        {/* Modal Header */}
        <div className="modal-header">
          {modalContent?.title &&
            <h4 className='font-tiempos text-h4-m md:text-h4 m-0'>{modalContent?.title}</h4>
          }
          <button
            className='absolute right-4 top-4'
            type="button"
            onClick={closeModal}
          >
            <IconClose />
          </button>
        </div>
        {/* Modal Content */}
        <div className='mt-6 lg:mt-8'>
          <div
            className="grid gap-6 lg:grid-cols-3 lg:gap-10"
            style={{ textAlign: 'center', margin: 'auto' }}
          >
            {modalContent?.contentList?.map((content, index) => (
              <div key={index} className="flex flex-col items-center justify-start gap-2 max-w-xs mx-auto">
                {content.icon &&
                  <img
                    src={content.icon.src}
                    alt={content.icon.alt}
                    width="40"
                    height="40"
                  />
                }
                <p className='sub-small m-0'>{content.title}</p>
                <p className='text-small m-0'>{content.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <button
        type="button"
        className={`modalBackdrop z-103 fixed top-0 left-0 h-full w-full cursor-pointer bg-black ${
          isOpen ? 'pointer-events-auto opacity-50' : 'opacity-0'
        }`}
        onClick={closeModal}
      >
        <span className="sr-only">Close Benefits Modal</span>
      </button>
    </div>
  );
}

export default SubscriptionBenefitsModal;
